const mockSelectedGroup = {
  groupId: 93201,
  categoryId: 36,
  categoryName: null,
  gradeId: 1,
  groupTypeId: 0,
  sequence: 0,
  name: "Clase con segmentos",
  code: "GNMR",
  welcomeMessage: "",
  welcomeSoundRecord: "",
  mainProfessor: 306046,
  startDate: "2026-08-05T00:00:00",
  finishDate: "2036-08-05T00:00:00",
  payeeTypeId: 1,
  mainLanguage: 2,
  isCoTeacher: false,
  isSequentialContent: false,
  isWorkAcceptedLate: false,
  automaticStudentSettings: false,
  allowStudentsSelfRegistration: true,
  allowStudentsTranslation: true,
  customStudentsTranslation: 0,
  students: 0,
  teachers: [],
  totalStudents: 0,
  totalTeachers: 0,
  missionsOrderBy: 0,
  groupPlacementId: 0,
  groupPlacementName: null,
  groupPlacementsCompleted: 0,
  assignContentMode: 4,
  googleClassroomCourseId: "",
  mandatoryTutorial: 0,
  totalActivitiesToGrade: 0,
  teacherActivitiesGradedAutomatically: false,
  learningLanguageId: 2,
  customLearningLanguageId: 0,
  pictogramPasswords: false,
  allowTeamActivities: true,
  hasAssignedContent: false,
  contentProfileId: 7,
  contentProfile: null,
  addedDate: null,
  isNewGroup: false,
  educationLevelId: 0,
  placements: [],
  isCustomIcon: false,
  iconURL: "/groupsIcon/Default/group_ico_flag_1.png",
  icon: "group_ico_flag_1.png",
  color: "#ff5a79",
}

export default mockSelectedGroup
